import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Shopfoo_Domain_Types_Common_OLID__OLID_get_Value } from "../Shopfoo.Domain.Types/Common.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { AppTranslations__get_Product, TranslationPages_Product__OpenLibraryAuthorPage_Z721C83C5 } from "../Shopfoo.Shared/Translations.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export class CoverContainer extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["None", "LinkToAuthorCard"];
    }
}

export function CoverContainer_$reflection() {
    return union_type("Shopfoo.Client.Components.CoverContainer", [], CoverContainer, () => [[], []]);
}

export class CoverSize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Small", "Medium", "Large"];
    }
}

export function CoverSize_$reflection() {
    return union_type("Shopfoo.Client.Components.CoverSize", [], CoverSize, () => [[], [], []]);
}

function CoverSizeModule_code(_arg) {
    switch (_arg.tag) {
        case 1:
            return "M";
        case 2:
            return "L";
        default:
            return "S";
    }
}

function CoverSizeModule_defaultWidth(_arg) {
    switch (_arg.tag) {
        case 1:
            return 140;
        case 2:
            return undefined;
        default:
            return 40;
    }
}

function CoverSizeModule_defaultHeight(_arg) {
    switch (_arg.tag) {
        case 1:
            return 200;
        case 2:
            return undefined;
        default:
            return 60;
    }
}

export function Cover_BookAuthor_2E4F4403(cover_BookAuthor_2E4F4403InputProps) {
    const sizeCssClass = cover_BookAuthor_2E4F4403InputProps.sizeCssClass;
    const container = cover_BookAuthor_2E4F4403InputProps.container;
    const coverSize = cover_BookAuthor_2E4F4403InputProps.coverSize;
    const translations = cover_BookAuthor_2E4F4403InputProps.translations;
    const author = cover_BookAuthor_2E4F4403InputProps.author;
    const key = cover_BookAuthor_2E4F4403InputProps.$key;
    const coverSize_1 = defaultArg(coverSize, new CoverSize(0, []));
    const container_1 = defaultArg(container, new CoverContainer(0, []));
    const coverUrl = `https://covers.openlibrary.org/a/olid/${Shopfoo_Domain_Types_Common_OLID__OLID_get_Value(author.OLID)}-${CoverSizeModule_code(coverSize_1)}.jpg`;
    const authorCardUrl = `https://openlibrary.org/authors/${Shopfoo_Domain_Types_Common_OLID__OLID_get_Value(author.OLID)}`;
    const img = createElement("img", {
        key: `${key}-img`,
        className: join(" ", toList(delay(() => append(singleton("object-cover object-top rounded-sm"), delay(() => {
            const matchValue = sizeCssClass;
            if (matchValue == null) {
                return empty();
            }
            else {
                return singleton(matchValue);
            }
        }))))),
        src: `${coverUrl}?default=${"https://openlibrary.org/static/images/icons/avatar_author-lg.png"}`,
        alt: `${author.Name} cover`,
    });
    if (container_1.tag === 1) {
        return createElement("a", {
            key: `${key}-link`,
            href: authorCardUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "ml-2 my-0.5 shrink-0 hover:opacity-80 transition-opacity",
            title: TranslationPages_Product__OpenLibraryAuthorPage_Z721C83C5(AppTranslations__get_Product(translations), author.Name),
            children: reactApi.Children.toArray([img]),
        });
    }
    else {
        return img;
    }
}

